import React from "react";
import { motion } from "framer-motion";

export default function Login() {
  const handleGoogle = () => {
    // REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
    const redirectUrl = window.location.origin + "/dashboard";
    window.location.href = `https://auth.emergentagent.com/?redirect=${encodeURIComponent(redirectUrl)}`;
  };

  return (
    <div className="min-h-screen grid grid-cols-1 lg:grid-cols-5 bg-white">
      {/* Left: form */}
      <div className="lg:col-span-2 flex flex-col justify-between p-8 lg:p-12 border-r border-black/10">
        <div className="flex items-center gap-3">
          <img src="/plasper-logo.png" alt="Plasper" className="w-10 h-10 object-contain" />
          <div className="leading-tight">
            <div className="font-display text-xl font-bold tracking-tight">Plasper Finans</div>
            <div className="text-[10px] text-neutral-500 uppercase tracking-[0.2em]">Ambalaj</div>
          </div>
        </div>

        <motion.div
          initial={{ opacity: 0, y: 12 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.5 }}
          className="max-w-md"
        >
          <p className="label-caps mb-4">01 / Giriş</p>
          <h1 className="font-display text-4xl sm:text-5xl font-bold tracking-tight leading-[1.05]">
            Nakit akışın,<br />tek ekranda.
          </h1>
          <p className="mt-4 text-neutral-600 leading-relaxed">
            Gelir, gider, banka ve cari hesaplarınızı Türk finans standartlarına uygun,
            tabüler ve şeffaf bir arayüzde yönetin.
          </p>

          <button
            data-testid="login-google-button"
            onClick={handleGoogle}
            className="brutal-btn mt-8 w-full flex items-center justify-center gap-3 bg-black text-white px-6 py-4 font-medium"
          >
            <GoogleIcon />
            <span>Google ile devam et</span>
          </button>

          <div className="mt-6 grid grid-cols-3 gap-3 text-xs text-neutral-600">
            {["Şifresiz", "7-gün oturum", "KVKK uyumlu"].map((t) => (
              <div key={t} className="border border-black/10 px-3 py-2 text-center uppercase tracking-widest">
                {t}
              </div>
            ))}
          </div>
        </motion.div>

        <div className="text-xs text-neutral-500">
          © {new Date().getFullYear()} Plasper Finans · TR · TRY
        </div>
      </div>

      {/* Right: architectural image */}
      <div className="hidden lg:block lg:col-span-3 relative overflow-hidden bg-neutral-900">
        <img
          src="https://images.unsplash.com/photo-1527576539890-dfa815648363?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjY2NjV8MHwxfHNlYXJjaHwxfHxhYnN0cmFjdCUyMGx1eHVyeSUyMGJsYWNrJTIwYW5kJTIwd2hpdGUlMjBhcmNoaXRlY3R1cmV8ZW58MHx8fHwxNzg0NzI0MDgzfDA&ixlib=rb-4.1.0&q=85"
          alt="Architecture"
          className="absolute inset-0 w-full h-full object-cover opacity-90"
        />
        <div className="absolute inset-0 bg-gradient-to-tr from-black/50 via-transparent to-transparent" />
        <div className="absolute bottom-8 left-8 right-8 text-white">
          <div className="label-caps text-white/80">Anlık nakit akışı takibi</div>
          <p className="font-display text-2xl sm:text-3xl mt-2 max-w-md">
            "Rakamlarını gördüğünde, kararlarını bilirsin."
          </p>
        </div>
        <div className="absolute top-8 right-8 flex gap-2">
          {["TRY", "TR-TR", "v1"].map((t) => (
            <span key={t} className="border border-white/40 text-white/80 px-3 py-1 text-xs uppercase tracking-widest">
              {t}
            </span>
          ))}
        </div>
      </div>
    </div>
  );
}

function GoogleIcon() {
  return (
    <svg width="18" height="18" viewBox="0 0 48 48" xmlns="http://www.w3.org/2000/svg">
      <path fill="#FFC107" d="M43.6 20.5H42V20H24v8h11.3c-1.6 4.7-6.1 8-11.3 8-6.6 0-12-5.4-12-12s5.4-12 12-12c3 0 5.8 1.1 7.9 3l5.7-5.7C34 6.1 29.3 4 24 4 12.9 4 4 12.9 4 24s8.9 20 20 20 20-8.9 20-20c0-1.2-.1-2.3-.4-3.5z" />
      <path fill="#FF3D00" d="M6.3 14.7l6.6 4.8C14.6 16 18.9 13 24 13c3 0 5.8 1.1 7.9 3l5.7-5.7C34 6.1 29.3 4 24 4c-7.7 0-14.3 4.4-17.7 10.7z" />
      <path fill="#4CAF50" d="M24 44c5.2 0 9.9-2 13.4-5.2l-6.2-5.2c-2 1.5-4.5 2.4-7.2 2.4-5.2 0-9.6-3.3-11.3-8L6.3 33.3C9.6 39.5 16.3 44 24 44z" />
      <path fill="#1976D2" d="M43.6 20.5H42V20H24v8h11.3c-.8 2.4-2.3 4.4-4.3 5.8l6.2 5.2C40.9 36.5 44 30.7 44 24c0-1.2-.1-2.3-.4-3.5z" />
    </svg>
  );
}
